import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { InboundCallsByPhoneNumberReportParameters } from '@ndt/report-output/inbound-calls-by-phone-number/inbound-calls-by-phone-number';
import { defaultAllMultiEntitySelectParameter } from '@ndt/report-output/shared/models/multi-entity-selection-report-parameter';
import { TimeZoneReportParameter } from '@ndt/report-output/shared/models/time-zone-report-parameters';
import { createDateRangeReportParameter } from '@ndt/reports/shared/models/date-range-report-parameter-value';
import { defaultTimeZoneParameter } from '@ndt/reports/shared/models/time-zone-parameter-value';
import {
   convertFromFormValueList,
   ParameterFormValueUnion,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-form-value';
import {
   BooleanReportParameter,
   convertToDateRangeReportParameter,
   convertToForm,
   EntitiesToIncludeParameter,
   ReportParametersUnion,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { ReportParameterConfig } from '@ndt/reports/shared/report-parameter-list/report-parameter.config';
import {
   ReportParameterFormService,
   ReportParameterFormServiceBase,
} from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { ReportParameters } from 'generated/graphql-types';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import { throwIfNullOrUndefined } from 'src/app/common-components/utils/type-safety';

export class InboundCallsByPhoneNumberParametersFormService
   extends ReportParameterFormServiceBase
   implements ReportParameterFormService<InboundCallsByPhoneNumberReportParameters>
{
   config: ReportParameterConfig[];

   form: UntypedFormGroup;

   constructor(fb: UntypedFormBuilder, private dateAdapter: LcsDateTimeAdapter<Date>) {
      super(fb);
      const initialValue: ReportParametersUnion[] = [
         {
            accountId: 0,
            all: true,
            names: [],
            parameterType: ReportParameters.PhoneNumbersToInclude,
            sortOrder: 2,
            values: [],
         },
         {
            parameterType: ReportParameters.DateRange,
            ...createDateRangeReportParameter(),
            sortOrder: 1,
         },
         {
            parameterType: ReportParameters.TimeZone,
            sortOrder: 3,
            value: '',
         },
         {
            parameterType: ReportParameters.SummaryOnly,
            sortOrder: 4,
            value: false,
         },
      ];

      this.config = initialValue.map((ap) => {
         return this.getReportParameterConfig(ap.parameterType);
      });

      this.form = convertToForm(initialValue, fb);
   }
   setValue(values: ParameterFormValueUnion[]): void {
      this.form.setValue(values, { emitEvent: false });
   }
   getValue(includeAskParameters?: boolean | undefined): InboundCallsByPhoneNumberReportParameters | null {
      const formValue = this.form.getRawValue();
      const values: ParameterFormValueUnion[] = formValue.values;
      const convertedValues = convertFromFormValueList(values);
      return this.convertValue(convertedValues);
   }
   convertValue(values: ReportParametersUnion[]): InboundCallsByPhoneNumberReportParameters | null {
      const phoneNumbers = values.find((v) => {
         return v.parameterType === ReportParameters.PhoneNumbersToInclude;
      }) as EntitiesToIncludeParameter | undefined;

      const summaryOnly = values.find((v) => {
         return v.parameterType === ReportParameters.SummaryOnly;
      }) as BooleanReportParameter | undefined;

      const timeZone = values.find((v) => {
         return v.parameterType === ReportParameters.TimeZone;
      }) as TimeZoneReportParameter | undefined;

      const output: InboundCallsByPhoneNumberReportParameters = {
         dateRange: throwIfNullOrUndefined(convertToDateRangeReportParameter(values, this.dateAdapter)),
         phoneNumbers: phoneNumbers
            ? {
                 accountId: phoneNumbers.accountId,
                 all: !!phoneNumbers?.all,
                 values: phoneNumbers.values || [],
              }
            : defaultAllMultiEntitySelectParameter,
         timeZone: timeZone
            ? {
                 value: timeZone.value,
              }
            : defaultTimeZoneParameter,
         summaryOnly: summaryOnly
            ? {
                 value: summaryOnly.value,
              }
            : {
                 value: false,
              },
      };

      return output;
   }
   isListComplete(values: ReportParametersUnion[], includeAskParameters?: boolean | undefined): boolean {
      const validParameters = !includeAskParameters
         ? values.filter((v) => {
              return !false;
           })
         : values;

      const dateRange = validParameters.find((v) => {
         return v.parameterType === ReportParameters.DateRange;
      });

      return !!dateRange;
   }
   patchSavedValues(values: ReportParametersUnion[], showAskToggle: boolean, showAskParameters: boolean): void {
      throw new Error('Method not implemented.');
   }
   resetConfig(): void {
      throw new Error('Method not implemented.');
   }
   // getLayoutConfigurations(values: ReportParametersUnion[]): {
   //    name: string | null;
   //    color: string | null;
   //    refreshTimeSeconds: number | null;
   // } {
   //    throw new Error('Method not implemented.');
   // }
}
